import { render } from "./AppNav.vue?vue&type=template&id=1e0228c8"
import script from "./AppNav.vue?vue&type=script&lang=js"
export * from "./AppNav.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__